export const MAX_RELATED_PRODUCTS_FOR_HALF_WIDTH_COLUMN = 8;
